export default {content:'We&nbsp;use cookies to&nbsp;improve the site. By&nbsp;continuing to&nbsp;use the site, you agree to&nbsp;our',policy:'Privacy Policy'};